import Wrapper from "../../../layout/Wrapper";
import PaymentHistoryComponent from "../../../screens/callcenters/payment-history";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Payment History",
	description: "",
};

export default function PaymentHistory() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<PaymentHistoryComponent />
		</Wrapper>
	);
}